import { FCX } from "@datassential/platform-ui-lib";
import FoodSectionsNav from "@pages/Food/components/SectionsNav/SectionsNav";
import FoodProfilePageFrame from "@pages/Food/components/FoodProfilePageFrame/FoodProfilePageFrame";
// Keep this import order: CRA emits CSS in first-import order, so moving these changes the legacy cascade.
import FoodProfileSections from "@pages/Food/legacy/components/FoodProfileSections/FoodProfileSections";
import FoodSectionConsumer from "@pages/Food/legacy/components/SectionConsumer/SectionConsumer";
import FoodSectionLaunches from "@pages/Food/components/SectionLaunches/SectionLaunches";
import { FoodSectionEnum } from "@pages/Food/Food.constants";
import useFoodProfilePage from "@pages/Food/hooks/useFoodProfilePage";
import FoodSummary from "@pages/Food/legacy/components/Summary/Summary";
import FoodSectionMenu from "@pages/Food/legacy/components/SectionMenu/SectionMenu";
import "./FoodLegacy.scss";

/**
 * Food Profile page as it is with the `Food Profile Refresh` flag OFF.
 * Frozen: don't add features here. Removing the flag deletes this folder (see `Food.tsx`).
 */
const FoodLegacy: FCX = () => {
    const { isLoading, summary, navItems, sections } = useFoodProfilePage();

    return (
        <FoodProfilePageFrame rootClassName="Food" isLoading={isLoading}>
            <FoodSummary data={summary}/>
            <FoodSectionsNav
                title={<>Know The Trend:<b data-testid="textFoodSectionsNavTitleWord"> {summary.name} </b></>}
                data={navItems}
            />
            <div
                className="Food__section"
                id={FoodSectionEnum.MenuAndConsumer}
                data-testid="blockFoodSectionMenuAndConsumer"
            >
                <FoodSectionMenu data={sections.menu}/>
                {sections.consumer.hasData && (
                    <FoodSectionConsumer data={sections.consumer}/>
                )}
            </div>
            <FoodProfileSections {...sections}/>
            <FoodSectionLaunches word={summary.name} setHasData={sections.setHasLaunches}/>
        </FoodProfilePageFrame>
    );
};

export default FoodLegacy;
